<script setup lang="ts">
import { ArrowLeft, Share2 } from "lucide-vue-next";

const emit = defineEmits<{
  back: [];
  share: [];
}>();
</script>

<template>
  <div class="sticky top-0 z-30 isolate border-b border-app-border bg-white">
    <div
      class="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-4 bg-white px-4 sm:px-6"
    >
      <button
        type="button"
        class="inline-flex h-10 items-center gap-2 rounded-lg px-2 text-base font-semibold text-app-text transition hover:bg-gray-100 sm:px-3"
        @click="emit('back')"
      >
        <ArrowLeft class="size-4" />
        <span class="hidden sm:inline">{{
          $t("worker_profile.back_to_search")
        }}</span>
        <span class="sm:hidden">{{ $t("worker_profile.back") }}</span>
      </button>

      <button
        type="button"
        class="inline-flex h-10 items-center gap-2 rounded-lg px-3 text-base font-semibold text-app-text transition hover:bg-gray-100"
        :aria-label="$t('worker_profile.share')"
        @click="emit('share')"
      >
        <Share2 class="size-4" />
        <span>{{ $t("worker_profile.share_short") }}</span>
      </button>
    </div>
  </div>
</template>
